




































































































import Vue from 'vue'
import { States, Modes, CardType, DeckType } from '../models'
import store from '../store'
import * as firebase from 'firebase/app'
import 'firebase/firestore'
import { calculateSuperMemo2Algorithm, formatTimeLater } from '../assets/utility'

export default Vue.extend({
  name: 'ReviseCard',
  data () {
    return {
      mode: 'question' as Modes,
      currentState: 0 as States,
      card: new CardType({}),
      editedCard: new CardType({}),
      deck: localStorage['Default'] ? JSON.parse(localStorage['Default']) : [] as DeckType,
      countdownId: 0,
      countdown: 0,
      nextScheduled: 0
    }
  },
  mounted () {
    // browser.runtime.sendMessage({})
    this.getNextCard()
    // required for website
    let user = firebase.auth().currentUser
    if (user) {
      this.getCards()
    }
  },
  watch: {
    user (val, oldVal) {
      // console.log('TCL: user -> val,oldVal', val, oldVal)
      if (val) {
        this.getCards()
      }
    },
    currentState (val:States) {
      let vm = this
      if (val !== 0) {
        vm.beginCountdown()
      }
    }
  },
  computed: {
    states () :Object {
      return {
        0: 'Bazinga!',
        200: 'Card Updated! ✌🏻',
        500: 'Unable to update.',
        201: `<span class="text-xs">Will help you recall that after</span><br><span>${formatTimeLater({ next: this.nextScheduled })}</span>`,
        501: 'Unable to save the progress',
        202: 'Card Deleted!',
        502: 'Unable to delete.'
      }
    },
    random () {
      return {
        front: 'meaning of crucial?',
        back: 'important'
      }
    },
    user () {
      return store.state.user
    },
    defaultText () {
      return browser.i18n.getMessage('extName')
    },
    chosenDeck () {
      return store.state.chosenDeck || store.state.user.uid
    },
    askLogin () {
      return store.state.askLogin
    }
  },
  methods: {
    beginCountdown () {
      var vm = this
      if (vm.countdownId !== 0) {
        clearInterval(vm.countdownId)
      }
      vm.countdown = 10
      vm.countdownId = window.setInterval(reduceTime, 1000)
      function reduceTime () {
        vm.countdown -= 1
        if (vm.countdown === 0) {
          clearInterval(vm.countdownId)
          vm.resetCurrentState()
        }
      }
    },
    resetCurrentState () {
      let vm = this
      vm.currentState = 0
    },
    async updateCard (key:string) {
      if (!this.editedCard.hasValues()) {
        this.currentState = 500
        return
      }
      if (this.askLogin) {
        this.$toasted.show('Please login 🙂', { type: 'info', duration: 3000 })
        return
      }
      try {
        var db = firebase.firestore()
        if (this.chosenDeck) {
          let res = await db.collection(`decks/${this.chosenDeck}/cards`).doc(key).update(this.editedCard.toString())
          this.currentState = 200
          this.mode = 'question'
          this.card = new CardType(this.editedCard)
        } else {
          throw new Error(`User not present ${this.user}`)
        }
      } catch (error) {
        console.log('err', error)
        this.currentState = 500
      }
    },
    getNextCard () {
      this.mode = 'question'
      if (this.deck.length > 0) {
        let card = this.deck.shift() as CardType
        // console.log('TCL: getNextCard -> card', card)
        this.card = new CardType(card)
      } else {
        this.card = new CardType({})
      }
    },
    setCount (key:string, count:number) {
      this.card = calculateSuperMemo2Algorithm(this.card, count)
      this.nextScheduled = this.card.nextPracticeDate
      console.log(formatTimeLater({ next: this.card.nextPracticeDate }))
      try {
        var db = firebase.firestore()
        db.collection(`decks/${this.chosenDeck}/cards`).doc(key).update(this.card.toString())
        this.getNextCard()
        this.currentState = 201
      } catch (err) {
        this.currentState = 501
        console.log('TCL: setCount -> err', err)
      }
    },
    editCard () {
      this.editedCard = new CardType(this.card)
      this.mode = 'edit'
    },
    deleteCard (key:string) {
      let userIsSure = confirm('Are you sure you want to delete this card ?')
      if (!userIsSure) {
        return
      }
      try {
        var db = firebase.firestore()
        db.collection(`decks/${this.chosenDeck}/cards`).doc(key).delete()
        this.currentState = 202
        this.getNextCard()
      } catch (err) {
        this.currentState = 502
        console.log('TCL: deleteCard -> err', err)
      }
    },
    showAnswer () {
      this.mode = 'answer'
    },
    async getCards () {
      let vm = this
      var db = firebase.firestore()
      // let temp = await db.collectionGroup('decks').where('owner', '==', this.chosenDeck).get()
      // console.log('temp', temp)
      // let temp = await db.collection('decks').get()
      // console.log('temp2', temp)
      // try {
      //   await firebase.firestore()
      //     .enablePersistence({ synchronizeTabs: true })
      // } catch (err) {
      //   if (err.code === 'failed-precondition') {
      //     console.log(err.code)
      //   } else if (err.code === 'unimplemented') {
      //     console.log(err.code)
      //   }
      // }
      let deckRef = db.collection(`decks/${this.chosenDeck}/cards`)
      deckRef.where('nextPracticeDate', '<', new Date().getTime()).orderBy('nextPracticeDate').limit(5).onSnapshot(function (deck) {
        // console.log(deck)
        if (!deck.empty) {
          let lDeck = [] as DeckType
          deck.forEach(function (doc) {
            // console.log('TCL: getCard -> doc', card)
            lDeck.push(new CardType({ ...doc.data(), id: doc.id }))
          })
          localStorage['Default'] = JSON.stringify(lDeck)
          // vm.deck = lDeck
          // if (!vm.card.hasValues()) {
          //   vm.getNextCard()
          // }
        } else {
          delete localStorage['Default']
        }
      })
    }
  }
})
